import { gql } from "@apollo/client";

export const GET_TICKETMASTER_EVENTS = gql`
  query GetTicketmasterEvents($limit: Int!, $offset: Int!, $where: events_bool_exp!) {
    events(
      where: $where
      order_by: { e_date: desc }
      limit: $limit
      offset: $offset
    ) {
      id: e_id
      event_name: e_name
      date: e_date
      time: e_cdt_date_with_year
      status: e_status
      venue: e_stadium_name
      venue_id: e_game_id
      location: e_city
      artist: e_brand_name
      league: e_state
      event_categories(limit: 1) {
        league_category {
          league {
            l_name
          }
        }
      }
      genre: e_platform_name
      price_range: e_address
      on_sale_date: e_created_at
      presale_date: e_updated_at
    }
    events_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_TICKETMASTER_EVENT_GLOBAL_STATS = gql`
  query GetTicketmasterEventGlobalStats {
    total: events_aggregate(
      where: {
        _and: [
          { e_platform_name: { _eq: "ticketmaster" } }
          { e_deleted_at: { _is_null: true } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    active: events_aggregate(
      where: {
        _and: [
          { e_platform_name: { _eq: "ticketmaster" } }
          { e_deleted_at: { _is_null: true } }
          { e_status: { _in: ["on-sale", "onsale", "active"] } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    deactivated: events_aggregate(
      where: {
        _and: [
          { e_platform_name: { _eq: "ticketmaster" } }
          { e_deleted_at: { _is_null: true } }
          {
            e_status: {
              _in: [
                "offsale",
                "off-sale",
                "closed",
                "postponed",
                "cancelled",
                "date-tbd",
                "deactivated",
              ]
            }
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_TICKETMASTER_LEAGUES = gql`
  query GetTicketmasterLeagues {
    leagues(
      where: { l_deleted_at: { _is_null: true } }
      order_by: { l_name: asc }
    ) {
      l_name
    }
  }
`;

export const GET_TICKETMASTER_ARTIST_NAMES = gql`
  query GetTicketmasterArtistNames {
    events(
      where: {
        _and: [
          { e_platform_name: { _eq: "ticketmaster" } }
          { e_deleted_at: { _is_null: true } }
          { e_brand_name: { _is_null: false, _neq: "" } }
        ]
      }
      distinct_on: e_brand_name
      order_by: { e_brand_name: asc }
      limit: 5000
    ) {
      artist: e_brand_name
    }
  }
`;

export const UPDATE_EVENT_STATUS = gql`
  mutation UpdateEventStatus($eventId: uuid!, $newStatus: String!) {
    update_events(
      where: { e_id: { _eq: $eventId } }
      _set: { e_status: $newStatus }
    ) {
      affected_rows
      returning {
        id: e_id
        event_name: e_name
        status: e_status
      }
    }
  }
`;
// Add this to your TicketmasterCatalogQuery.ts file

export const BULK_UPDATE_EVENT_STATUS = gql`
  mutation BulkUpdateEventStatus($eventIds: [uuid!]!, $newStatus: String!) {
    update_events(
      where: { e_id: { _in: $eventIds } }
      _set: { e_status: $newStatus }
    ) {
      affected_rows
      returning {
        id: e_id
        status: e_status
      }
    }
  }
`;